import { connect } from 'react-redux'
import * as selector from '../../state/auth/selector'
import HasNotAuthorization from './HasNotAuthorization'

const mapStateToProps = (state, props) => {
    return {
        hasRole: selector.selectHasRole(state, props.requiredRole),
    }
}

const mapDispatchToProps = {
}

export default connect(mapStateToProps, mapDispatchToProps)(HasNotAuthorization)



// WEBPACK FOOTER //
// ./src/modules/security/component/auth/HasNotAuthorizationContainer.js